import { useApi } from '@backstage/core-plugin-api';
import GroupOutlined from '@mui/icons-material/GroupOutlined';
import { SidebarItem } from '@traton/devportal-env-kit-app';
import { useEffect, useState } from 'react';
import { portalgroupsApiRef } from '../../api/PortalgroupsApi';

export const PortalgroupsSidebarItem = () => {
  const api = useApi(portalgroupsApiRef);
  const [canAccess, setCanAccess] = useState(false);

  useEffect(() => {
    api
      .checkPermissions()
      .then(perms => setCanAccess(perms.read))
      .catch(() => setCanAccess(false));
  }, [api]);

  if (!canAccess) return null;

  return (
    <SidebarItem
      icon={GroupOutlined}
      to="/groups"
      text="Groups"
      pluginId="portalgroups"
    />
  );
};
